import React from "react";
import { motion } from "framer-motion";
import { scoreToColor } from "@/lib/scoring";

export const PillarBar = ({ label, score, weight, testId, action }) => {
  const isNA = score === null || score === undefined;
  const safe = isNA ? 0 : Math.max(0, Math.min(100, score || 0));
  const color = isNA ? "var(--rg-muted)" : scoreToColor(safe);
  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex items-baseline justify-between">
        <div>
          <div className="text-sm font-semibold text-[var(--rg-text-strong)]">{label}</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--rg-muted)] font-mono">
            Weight {weight}
            {isNA && <span className="ml-2 text-[var(--rg-amber)]">· Not yet scored</span>}
          </div>
        </div>
        <div className="font-heading font-extrabold text-2xl" style={{ color }}>
          {isNA ? (
            <span data-testid={`${testId}-na`}>
              N/A
              <span className="text-[10px] text-[var(--rg-muted)] font-mono ml-1">/100</span>
            </span>
          ) : (
            <>
              {Math.round(safe)}
              <span className="text-[10px] text-[var(--rg-muted)] font-mono ml-1">/100</span>
            </>
          )}
        </div>
      </div>
      <div className="h-2 bg-[var(--rg-surface)] border border-[var(--rg-border)] rounded-sm overflow-hidden">
        {!isNA && (
          <motion.div
            className="h-full"
            style={{ backgroundColor: color }}
            initial={{ width: 0 }}
            animate={{ width: `${safe}%` }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        )}
        {isNA && (
          <div
            className="h-full opacity-30"
            style={{
              background: "repeating-linear-gradient(45deg, var(--rg-muted) 0 6px, transparent 6px 12px)",
            }}
          />
        )}
      </div>
      {action}
    </div>
  );
};

export default PillarBar;
